<template>
  <div
    id="wa-chat"
    @drop.prevent="addFile"
    @dragover.prevent
    @paste="onPaste($event)"
    class="wa-chat"
    style="
      max-height: calc(100vh - 60px);
      overflow-y: hidden;
      overflow-x: hidden;
    "
  >
    <!-- #region MENU-->
    <v-toolbar color="grey lighten-2" elevation="1" dense>
      <v-list-item-avatar
        color="grey"
        @click="expand = !expand"
        style="cursor: pointer"
        class="userimage"
        small
      >
        <v-img
          :src="`${ip}/gravacoes/clientes/${atendimento.idCliente}.jpg`"
        ></v-img>
      </v-list-item-avatar>
      <v-list-item-content class="ml-0">
        <v-list-item-title>{{ atendimento.fromName }}</v-list-item-title>
        <v-list-item-subtitle class="font-weight-light text--secondary">{{
          formataData(atendimento.dataIni)
        }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-btn icon @click="modalEditar = true">
        <v-icon>mdi-pencil</v-icon></v-btn
      >
      <!-- <span class="green--text ml-2">00:45:12</span> -->
      <v-spacer></v-spacer>

      <a
        :href="cliente.url"
        target="_blank"
        class="ml-5"
        v-if="cliente && cliente.url"
      >
        <v-icon color="primary">mdi-open-in-new</v-icon>
      </a>
      <v-icon class="ml-5" :color="getColorByStatus()">{{
        getIconByStatus()
      }}</v-icon>
      <span class="ml-2 d-md-none d-lg-flex d-xl-flex d-sm-none">{{
        getStatus(atendimento.status)
      }}</span>

      <v-icon class="ml-5">mdi-database</v-icon>
      <span class="ml-2">{{ atendimento.queue }}</span>

      <v-icon class="ml-5">mdi-pound</v-icon>
      <span class="ml-2">{{ atendimento.id }}</span>

      <v-icon class="ml-5">mdi-alarm</v-icon>
      <relogio
        v-show="atendimento.status !== 'Encerrado'"
        :datainicial="new Date(atendimento.dataIni)"
      ></relogio>
    </v-toolbar>
    <!-- #endregion MENU-->

    <v-main class="mt-1" style="display: flex; flex-direction: column">
      <!-- #region MESSAGES-->
      <v-alert
        v-model="expand"
        class="mx-auto"
        elevation="2"
        dismissible
        colored-border
        border="top"
        color="#FFAB40"
        style="width: 60%; position: fixed; z-index: 99999; left: 30%"
        icon="mdi-clipboard-account"
      >
        <template v-for="(value, key, index) in cliente">
          <v-text-field
            v-if="
              key !== `CamposAdicionais` &&
              key !== `NumerosAdicionais` &&
              key !== `url`
            "
            :key="index + `adicionais`"
            style="width: 60%"
            dense
            :label="t(`${key}`)"
            :value="value"
            readonly
          ></v-text-field>
          <template v-if="key === `url`">
            <!-- <v-text-field :key="index+`adicionais`" style="width:60%" dense :label="key" readonly></v-text-field> -->
            <a :key="index + `url`" :href="value" target="_blank">
              <v-icon color="primary">mdi-open-in-new</v-icon>
            </a>
          </template>
          <template v-if="key === `CamposAdicionais`">
            <v-text-field
              v-for="campo in value"
              :key="campo.id + `campos`"
              style="width: 60%"
              dense
              :label="t(`${campo.nome}`)"
              :value="campo.valor"
              readonly
            ></v-text-field>
          </template>
          <template v-if="key === `NumerosAdicionais`">
            <v-text-field
              v-for="numero in value"
              :key="numero.id + `numeros`"
              style="width: 60%"
              dense
              :label="t(`${numero.nome}`)"
              :value="numero.numero"
              readonly
            ></v-text-field>
          </template>
        </template>
      </v-alert>
      <div class="wa-chat" v-on:scroll="handleScroll" :style="getStyleWaChat()">
        <Messages
          :messages="atendimento.pesquisa ? messagesAux : atendimento.messages"
          @replyMsg="replyMsg($event)"
          @deleteMsg="
            $bvModal.show('delete-modal');
            deletedMsg = $event;
          "
          @openImage="openImage($event.file, $event.local)"
        />
      </div>
      <v-footer
        color="grey lighten-2"
        elevation="0"
        class="pl-2 pr-2"
        padless
        style="min-height: 48px"
      >
        <template v-if="!atendimento.pesquisa">
          <v-alert
            v-model="alertReplied"
            v-if="repliedMsg"
            class="mx-auto"
            text
            elevation="2"
            dismissible
            colored-border
            border="left"
            height="60"
            :color="repliedMsg.inOut === 1 ? 'info' : 'warning'"
            style="width: 100%"
          >
            <div
              style="font-style: italic; font-weight: bold; font-size: 0.8em"
            >
              {{
                repliedMsg.inOut === 1
                  ? atendimento.fromName
                  : atendimento.ultimoAgente
              }}
            </div>
            <div
              style="
                width: 60vh;
                overflow-x: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-wrap: break-word;
              "
            >
              <span v-if="repliedMsg.status !== `deleted`">{{
                repliedMsg.texto
              }}</span>
              <span v-else>{{ t(`mensagemApagada`) }}</span>
            </div>
          </v-alert>
          <emoji-picker @emoji="insert" :search="search">
            <div
              class="emoji-invoker"
              slot="emoji-invoker"
              slot-scope="{ events: { click: clickEvent } }"
              @click.stop="clickEvent"
            >
              <svg
                height="24"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                  d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                />
              </svg>
            </div>
            <div
              slot="emoji-picker"
              slot-scope="{ emojis, insert }"
              style="flex: 1"
            >
              <div class="emoji-picker">
                <div class="emoji-picker__search">
                  <input type="text" v-model="search" v-focus />
                </div>
                <div>
                  <div v-for="(emojiGroup, category) in emojis" :key="category">
                    <h5>{{ category }}</h5>
                    <div class="emojis">
                      <span
                        v-for="(emoji, emojiName) in emojiGroup"
                        :key="emojiName"
                        @click="insert(emoji)"
                        :title="emojiName"
                        >{{ emoji }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </emoji-picker>
          <v-speed-dial v-model="fab" class="ml-2">
            <template v-slot:activator>
              <v-btn v-model="fab" icon>
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>mdi-plus-circle</v-icon>
              </v-btn>
            </template>

            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  dark
                  small
                  color="blue"
                  @click="modalTransfere = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-share</v-icon>
                </v-btn>
              </template>
              <span>{{ t(`transferirAtendimento`) }}</span>
            </v-tooltip>

            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  dark
                  small
                  color="yellow"
                  @click="modalClassificacao = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-star</v-icon>
                </v-btn>
              </template>
              <span>{{ t(`classificarAtendimento`) }}</span>
            </v-tooltip>

            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  dark
                  small
                  color="red"
                  @click="modalEncerra = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-check-bold</v-icon>
                </v-btn>
              </template>
              <span>{{ t(`encerrarAtendimento`) }}</span>
            </v-tooltip>
            <v-tooltip
              right
              v-if="atendimento.queueTypeID !== 1 && cliente && cliente.numero"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  dark
                  small
                  color="primary"
                  @click="modalLigacao = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-phone</v-icon>
                </v-btn>
              </template>
              <span>{{ t(`novaLigacao`) }}</span>
            </v-tooltip>
            <v-tooltip
              right
              v-if="atendimento.queueTypeID !== 4 && cliente && cliente.email"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  dark
                  small
                  color="indigo"
                  @click="modalEmail = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-gmail</v-icon>
                </v-btn>
              </template>
              <span>{{ t(`novoEmail`) }}</span>
            </v-tooltip>
            <v-tooltip
              right
              v-if="
                atendimento.queueTypeID !== 3 &&
                atendimento.queueTypeID !== 5 &&
                cliente &&
                cliente.numero
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  dark
                  small
                  color="success"
                  @click="modalWhats = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-whatsapp</v-icon>
                </v-btn>
              </template>
              <span>{{ t(`novoWhatsApp`) }}</span>
            </v-tooltip>
            <v-tooltip right v-if="atendimento.queueTypeID === 4">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  dark
                  small
                  color="indigo"
                  @click="modalEmailExterno = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-forward</v-icon>
                </v-btn>
              </template>
              <span>{{ t(`encaminhar`) }}</span>
            </v-tooltip>
            <v-tooltip right v-if="atendimento.queueTypeID === 5">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  fab
                  dark
                  small
                  color="success"
                  @click="modalTemplate = true"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon dark>mdi-message-bookmark-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ t(`enviarTemplate`) }}</span>
            </v-tooltip>
          </v-speed-dial>
          <v-textarea
            :disabled="
              (atendimento.queueTypeID === 5 &&
                atendimento.messages.length === 0) ||
              !enviarMensagem
            "
            class="ml-2"
            autofocus
            hide-details
            dense
            solo
            rounded
            flat
            background-color="white"
            clearable
            :label="t(`digiteAqui`)"
            auto-grow
            rows="1"
            row-height="15"
            v-model="message"
            @keyup="openUrl($event)"
            @keypress.enter.exact.prevent="send()"
            @keyup.shift.enter.exact.prevent.stop="message"
            @keyup.220.prevent="getAutoComplete()"
            @keyup.226.prevent="getAutoComplete()"
          ></v-textarea>
          <v-btn
            class="ml-2"
            icon
            @click="$bvModal.show('anexar-modal')"
            :disabled="this.atendimento.pesquisa || !enviarMensagem"
          >
            <v-icon class="icon">mdi-paperclip</v-icon>
          </v-btn>
          <v-btn class="ml-2" @click="send()" icon v-show="message">
            <v-icon>mdi-send</v-icon>
          </v-btn>
          <v-btn
            class="ml-2"
            icon
            v-show="!message && !isRecording"
            @click="startRecording()"
            :disabled="!enviarMensagem"
          >
            <v-icon>mdi-microphone</v-icon>
          </v-btn>
          <div v-show="isRecording" class="ml-2">
            <v-btn
              icon
              @click="cancelRecording()"
              color="error"
              style="flex: 1"
            >
              <v-icon>mdi-close-circle</v-icon>
            </v-btn>
            <span class="mt-2" style="flex: 2">
              <relogio :datainicial="new Date()"></relogio>
            </span>
            <v-btn
              icon
              @click="stopRecording()"
              color="success"
              style="flex: 1"
            >
              <v-icon>mdi-check-circle</v-icon>
            </v-btn>
          </div>
        </template>
      </v-footer>
      <!-- #endregion FIM MESSAGES-->
    </v-main>
    <!-- MODAL cliente -->
    <b-modal
      id="modal-cliente"
      size="xl"
      centered
      header-bg-variant="default"
      header-text-variant="dark"
      style="max-height: 80vh !important; overflow-y: scroll !important"
    >
      <template v-slot:modal-header>
        <span> <v-icon class="icon">mdi-file</v-icon>Dados do cliente </span>
      </template>
      <Cliente></Cliente>
      <template v-slot:modal-footer="{ ok }">
        <b-button variant="light" @click="ok()">Fechar</b-button>
      </template>
    </b-modal>
    <!-- MODAL cliente -->

    <!-- MODAL ANEXO -->
    <b-modal
      id="autocomplete-modal"
      centered
      header-bg-variant="default"
      header-text-variant="dark"
    >
      <template v-slot:modal-header>
        <span> <v-icon class="icon">mdi-file</v-icon>Auto Complete </span>
      </template>
      <v-text-field
        prepend-icon="mdi-closed-caption"
        v-model="autoCompleteSearch"
        :label="t(`pesquiseAqui`)"
        autofocus
        v-on:keyup.enter="selectAutocomplete(autoCompleteFiltered[0])"
        required
      ></v-text-field>
      <v-list subheader>
        <v-virtual-scroll
          :items="autoCompleteFiltered"
          :item-height="100"
          :height="200"
          v-if="autoCompleteFiltered && autoCompleteFiltered.length > 0"
        >
          <template v-slot="{ item }">
            <v-list-item @click="selectAutocomplete(item)">
              <v-list-item-avatar>
                <v-icon class="icon">mdi-file</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ item.nome }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.texto }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-list>

      <template v-slot:modal-footer="{ ok }">
        <b-button variant="light" @click="ok()">Ok</b-button>
      </template>
    </b-modal>

    <b-modal
      id="anexar-modal"
      centered
      header-bg-variant="default"
      s
      header-text-variant="dark"
    >
      <template v-slot:modal-header>
        <span>
          <v-icon class="icon">mdi-file</v-icon>
          {{ t(`adicionarArquivos`) }}
        </span>
      </template>
      <form>
        <v-file-input
          v-model="files"
          chips
          multiple
          required
          :disabled="files && files.length == 1"
        ></v-file-input>
        <v-text-field
          prepend-icon="mdi-closed-caption"
          v-model="legenda"
          :label="t(`legenda`)"
          @keydown="event.prevent.default()"
          required
        ></v-text-field>
        <b-progress
          show-progress
          :value="uploadStatus"
          :variant="`warning`"
          :key="`warning`"
        ></b-progress>
      </form>
      <template v-slot:modal-footer="{ ok }">
        <b-button
          variant="light"
          v-show="uploadStatus === 0"
          @click="
            ok();
            files = [];
          "
          >{{ t(`cancelar`) }}</b-button
        >
        <b-button
          :disabled="!files || (files.length === 1 && uploadStatus !== 0)"
          variant="light"
          @click="sendFile()"
          >{{ t(`anexar`) }}</b-button
        >
      </template>
    </b-modal>
    <!-- MODAL ANEXO -->
    <!-- MODAL MEDIA -->
    <v-dialog
      v-model="modal"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark style="position: relative">
          <v-btn
            icon
            dark
            @click="
              modal = false;
              file = null;
            "
            style="position: absolute; right: 25px"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-card class="hover" style="text-align: center">
                <image-magnifier
                  :src="ip + file.caminho"
                  v-if="
                    file !== null &&
                    file.mimeType &&
                    file.mimeType !== null &&
                    file.mimeType.indexOf('image') !== -1 &&
                    local
                  "
                  :zoom-src="ip + file.caminho"
                  width="auto"
                  style="image-orientation: from-image"
                  :height="windowHeight"
                  zoom-width="400"
                  :zoom-height="windowHeight"
                ></image-magnifier>
                <image-magnifier
                  :src="file.caminho"
                  v-if="
                    file !== null &&
                    file.mimeType &&
                    file.mimeType !== null &&
                    file.mimeType.indexOf('image') !== -1 &&
                    !local
                  "
                  :zoom-src="file.caminho"
                  width="auto"
                  :height="windowHeight"
                  zoom-width="400"
                  :zoom-height="windowHeight"
                ></image-magnifier>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn icon v-if="file !== null">
                    <a :href="ip + file.caminho" download>
                      <v-icon>mdi-download</v-icon>
                    </a>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- MODAL MEDIA -->

    <v-dialog v-model="modalEmailExterno">
      <v-form v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>Encaminhar para outro destinatario</v-card-title>

          <v-card-text>
            <v-text-field
              v-model="emailExterno"
              label="Email"
              required
              type="email"
              :rules="[(v) => !!v || 'Campo obrigatório']"
            ></v-text-field>
            <v-text-field
              v-model="message"
              label="Mensagem"
              required
              type="text"
              :rules="[(v) => !!v || 'Campo obrigatório']"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="
                send();
                modalEmailExterno = false;
              "
              >{{ t("continuar") }}</v-btn
            >
            <v-btn color="error" text @click="modalEmailExterno = false">{{
              t("cancelar")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- MODAL editar contato -->

    <!-- MODAL editar contato -->

    <!-- MODAL CLASSIFICACAO -->
    <Classificar
      :open="modalClassificacao"
      :queueTypeID="atendimento.queueTypeID"
      :atendimento="atendimento"
      :fila="fila"
      v-on:updateClassificar:open="modalClassificacao = $event"
    />
    <Encerrar
      :open="modalEncerra"
      :queueTypeID="atendimento.queueTypeID"
      :atendimento="atendimento"
      :fila="fila"
      v-on:updateEncerrar:open="modalEncerra = $event"
    />
    <!-- MODAL CLASSIFICACAO -->
    <EditarContato
      v-if="clienteAux"
      :open="modalEditar"
      :cliente="clienteAux"
      :atendimento="atendimento"
      v-on:editar:open="modalEditar = $event"
    />
    <!-- MODAL encerramento -->

    <b-modal id="encerra-modal" centered header-bg-variant="danger">
      <template v-slot:modal-header variant="light">
        <span style="color: #fff">{{ t("Alerta") }}</span>
      </template>
      <span>{{ t(`fraseEncerramento`) }}</span>
      <template v-slot:modal-footer="{ ok }">
        <b-button
          variant="light"
          @click="
            ok();
            encerraAtendimento();
          "
          >{{ t(`sim`) }}</b-button
        >
        <b-button variant="light" @click="ok()">{{ t(`nao`) }}</b-button>
      </template>
    </b-modal>
    <!-- MODAL encerramento -->
    <!-- MODAL deleteMsg -->

    <b-modal id="delete-modal" centered header-bg-variant="danger">
      <template v-slot:modal-header variant="light">
        <span style="color: #fff">{{ t("Alerta") }}</span>
      </template>
      <span>{{ t(`fraseDeleteMsg`) }}</span>
      <template v-slot:modal-footer="{ ok }">
        <b-button
          variant="light"
          @click="
            ok();
            deleteMsg({ msg: deletedMsg, protocolo: atendimento.id });
          "
          >{{ t(`sim`) }}</b-button
        >
        <b-button variant="light" @click="ok()">{{ t(`nao`) }}</b-button>
      </template>
    </b-modal>
    <!-- MODAL deleteMSg -->

    <!-- MODAL transferencia -->
    <Transferencia
      :open="modalTransfere"
      :atendimento="atendimento"
      v-on:update:open="modalTransfere = $event"
    ></Transferencia>
    <!-- MODAL transferencia -->

    <NovoWhats
      :open="modalWhats"
      :item="cliente"
      v-on:update="closeModalWhats($event)"
    />
    <Template
      :open="modalTemplate"
      v-on:update="modalTemplate = false"
      v-on:sendTemplate="sendTemplate($event)"
    />
    <v-dialog v-model="modalLigacao" v-if="cliente">
      <Dial v-on:update="modalLigacao = $event" :numero="cliente.numero" />
    </v-dialog>
    <NovoEmail
      :open="modalEmail"
      :item="cliente"
      v-on:update="closeModalEmail($event)"
    />
  </div>
</template>
   
<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import Relogio from "./Relogio";
import Cliente from "./Cliente";
import moment from "moment-timezone";
import Transferencia from "./dialogs/Transferencia";
import Classificar from "./dialogs/Classificar";
import Encerrar from "./dialogs/Encerrar";
import vmsg from "vmsg";
import uid from "uid";
const recorder = new vmsg.Recorder({
  wasmURL: "https://unpkg.com/vmsg@0.3.0/vmsg.wasm",
});
import { ImageMagnifier } from "vue-image-magnifier";
import filter from "../plugins/Filter";
import { debounce } from "../plugins/Debounce";
import WhatsTextFormatter from "../plugins/WhatsTextFormatter";
import EmojiPicker from "vue-emoji-picker";
import Messages from "./atendimento/Messages";
const toFile = require("data-uri-to-file");
import NovoWhats from "./dialogs/NovoWhats";
import Dial from "./Home";
import NovoEmail from "./dialogs/NovoEmail";
import Template from "./dialogs/Template";
import EditarContato from "./dialogs/EditarContato.vue";
let chunks = [];

export default {
  name: "Chat",
  components: {
    Relogio,
    Transferencia,
    Cliente,
    ImageMagnifier,
    EmojiPicker,
    Classificar,
    Messages,
    NovoWhats,
    Dial,
    NovoEmail,
    EditarContato,
    Template,
    Encerrar,
  },
  data() {
    return {
      expand: false,
      items: [{ title: "Responder" }],
      page: 1,
      cliente: null,
      search: null,
      modalEmailExterno: false,
      autoCompleteSearch: null,
      input: null,
      clienteAux: null,
      isRecording: false,
      blob: null,
      files: [],
      legenda: null,
      modal: false,
      modalAnexo: false,
      modalEncerra: false,
      modalClassificacao: false,
      modalTransfere: false,
      modalEncerra: false,
      modalCliente: false,
      modalLigacao: false,
      modalTemplate: false,
      modalEmail: false,
      modalWhats: false,
      modalEditar: false,
      deletedMsg: null,
      file: null,
      local: false,
      emailExterno: null,
      messagesAux: [],
      ENTER_KEY: 13,
      message: null,
      ip: "http://" + JSON.parse(localStorage.getItem("config")).servidor,
      config: {
        readOnly: false,
        placeholder: "Digite uma mensagem",
      },
      fab: false,
      windowHeight: 0,
      totalHeight: 0,
      autoCompletes: [],
      repliedMsg: null,
      divMsgHeight: 160,
      alertReplied: false,
      valid: false,
      clienteAux: null,
      keyBindings: [
        {
          key: 13,
          shiftKey: true,
          method: () => {
            this.send();
          },
        },
        {
          key: 220,
          method: () => {
            this.getAutoComplete();
          },
        },
        {
          key: 226,
          method: () => {
            this.getAutoComplete();
          },
        },
      ],
    };
  },
  mounted: function () {
    this.$nextTick(function () {});
  },
  async created() {
    this.calcHeight();
    this.getClienteByID();
    await this.getMessages();
    window.addEventListener("resize", () => {
      this.calcHeight();
    });
    let txtCache = localStorage.getItem(this.atendimento.id);
    if (txtCache && txtCache != `null`) {
      this.message = txtCache;
    } else {
      this.message = "";
    }
    //descomentar caso volte a usar o historico com scroll
    //if (!this.atendimento.pesquisa) this.atendimento.messages = [];
    // this.page = 0;
    // this.getHistorico();
  },

  computed: {
    ...mapState(`xc`, {
      messages: (state) => state.atendimento.messages,
      atendimento: (state) => state.atendimento,
      clientes: (state) => state.clientes,
      modalTransferencia: (state) => state.transferenciaModal,
      uploadStatus: (state) => state.uploadStatus,
      lastMsg: (state) => state.atendimento.lastMsg,
      sendSuccessId: (state) => state.sendSuccessId,
      filas: (state) => state.filas,
      enviarMensagem: (state) => state.enviarMensagem,
    }),
    record() {
      document.querySelector(".record");
    },
    stop() {
      document.querySelector(".stop");
    },
    soundClips() {
      document.querySelector(".sound-clips");
    },
    div() {
      document.getElementById(`wa-chat`);
    },
    ...mapState(`auth`, {
      user: (state) => state.user,
    }),
    sortMsgById() {
      let msg = this.messages;
      return msg.sort(function (a, b) {
        return a.id - b.id;
      });
    },
    random() {
      return uid();
    },
    autoCompleteFiltered() {
      if (
        this.autoCompleteSearch &&
        this.autoCompleteSearch.length > 2 &&
        this.autoCompletes &&
        this.autoCompletes.length > 0
      ) {
        return filter.transform(this.autoCompletes, this.autoCompleteSearch, [
          `nome`,
          `texto`,
        ]);
      } else {
        return this.autoCompletes;
      }
    },
    fila() {
      return this.filas.find((f) => f.name === this.atendimento.queue);
    },
  },
  watch: {
    repliedMsg(nw) {
      if (!nw) this.alertReplied = false;
      if (nw) this.alertReplied = true;
    },
    alertReplied(nw) {
      if (!nw) {
        this.divMsgHeight = 160;
        this.repliedMsg = null;
      }
    },
    sendSuccessId() {
      // if (nw) {
      //   this.messages.map((m) => (m.status = `seen`));
      // }
    },
    messages() {
      setTimeout(() => {
        var container = this.$el.querySelector(".wa-chat");
        container.scrollTop = container.scrollHeight;
      }, 500);
    },
    message: debounce(function (newVal) {
      localStorage.setItem(this.atendimento.id, newVal);
    }, 500),
    async atendimento() {
      console.log(`ATENDIMENTO`, this.atendimento);
      // console.log(`ATENDIMENTO`, this.atendimento.messages.length);
      await this.getMessages();
      this.getClienteByID();
      let txtCache = localStorage.getItem(this.atendimento.id);
      if (txtCache && txtCache != `null`) {
        this.message = txtCache;
      } else {
        this.message = "";
      }
      ///this.getClienteByID(nw.idCliente);
    },
    modalTransferencia() {
      this.modalTransfere = !this.modalTransfere;
    },
    uploadStatus(nw) {
      if (nw === 100) {
        this.$bvModal.hide("anexar-modal");
        this.files = [];
      }
    },
    input: debounce(function (newVal) {
      this.autoCompleteSearch = newVal;
    }, 500),
  },
  methods: {
    openUrl(event) {
      console.log(event.keyCode);
      if (event.keyCode == this.user.atalho_url) {
        document.getElementById(`clienteUrl`).click();
      }
    },
    closeModalWhats(event) {
      if (event === "new") {
        this.modalWhats = false;
        this.$router.push(`/home`);
      }
      this.modalWhats = false;
    },
    closeModalLigacao(event) {
      if (event === "new") {
        this.modalLigacao = false;
      }
      this.modalLigacao = false;
    },
    closeModalEmail(event) {
      if (event === "new") {
        this.modalEmail = false;
        this.$router.push(`/home`);
      }
      this.modalEmail = false;
    },
    reader(file) {
      return new Promise((resolve) => {
        const fileReader = new FileReader();
        fileReader.onload = () => resolve(fileReader.result);
        fileReader.readAsDataURL(file);
      });
    },
    async getClienteByID() {
      try {
        let retorno = null;
        if (this.atendimento.idCliente) {
          retorno = await this.getDefault(
            `/api/v2/clientes/${this.atendimento.idCliente}`
          );
        }

        if (!this.atendimento.idCliente) {
          let numero = this.atendimento.fromID.split(`@`)[0];
          retorno = await this.getDefault(`/api/v2/clientesByNumero/${numero}`);
          this.atendimento.idCliente = retorno.id;
        }
        if (!retorno) return;
        let div = document.getElementById(`app`);
        let a = document.createElement(`a`);
        a.href = retorno.url;
        a.target = `_blank`;
        a.style.display = `none`;
        a.id = "clienteUrl";
        div.appendChild(a);
        this.clienteAux = retorno;
        if (this.user.abrir_url && retorno.url) {
          a.click();
          // document.getElementById("link").click();
        }
        //eslint-disable-next-line no-unused-vars
        /* eslint-disable  */
        let { idGrupo, profileImage, isBusiness, clienteGrupo, id, ...data } =
          retorno;
        /* eslint-enable */

        data = Object.entries(data).reduce(
          (a, [k, v]) => (v ? ((a[k] = v), a) : a),
          {}
        );
        if (data.CamposAdicionais && data.CamposAdicionais.length == 0)
          delete data.CamposAdicionais;
        if (data.NumerosAdicionais && data.NumerosAdicionais.length == 0)
          delete data.NumerosAdicionais;
        this.cliente = data;
      } catch (error) {
        console.error(error);
      }
    },
    async getMessages() {
      try {
        console.log(`GET MESSAGE`, this.atendimento.id);
        this.messagesAux = [];
        let retorno = await this.getDefault(
          `/api/v2/chat/${this.atendimento.id}/mensagens?max=-1&page=1`
        );

        if (this.atendimento.pesquisa) this.messagesAux = retorno.dados;
        if (!retorno.dados) return this.addMessages([]);
        await this.addMessages(retorno.dados);
      } catch (error) {
        console.error(error);
      }
    },
    async onPaste(event) {
      if (event.clipboardData.files.length) {
        let file = event.clipboardData.files[0];
        let teste = await this.reader(file);
        file.caminho = teste;
        this.files.push(file);
        this.$bvModal.show("anexar-modal");
        // toFile(file).then((file) => {
        //   file.path = file;
        //   this.files.push(file);
        //   this.$bvModal.show("anexar-modal");
        // });
        // var oReq = new XMLHttpRequest();
        // var data = new FormData();

        // data.append("csrf", "TOKEN");

        // oReq.open("POST", "/file");
        // oReq.setRequestHeader("Accept", "application/json");

        // /* Create a new FileReader. */
        // var fileReader = new FileReader();

        // fileReader.onload = function (event) {
        //   data.append("file", this.result);
        //   oReq.send(data);
        // };
        // fileReader.readAsDataURL(file);
      }
    },
    getIcon(key) {
      let icon = "mdi-file-document";
      if (key === "numero") icon = "mdi-phone";
      if (key === "isBusiness") icon = "mdi-whatsapp";
      if (key === "email") icon = "mdi-email";
      return icon;
    },
    getIconByStatus() {
      if (this.atendimento.status === "Entrou") {
        return "mdi-sticker-check";
      } else if (this.atendimento.status === "Encerrado") {
        return "mdi-sticker-remove";
      } else {
        return "mdi-sticker-alert";
      }
    },
    getColorByStatus() {
      if (this.atendimento.status === "Entrou") {
        return "success";
      } else if (this.atendimento.status === "Encerrado") {
        return "error";
      } else {
        return "#FBC02D";
      }
    },
    insert(emoji) {
      // var element = document.getElementsByClassName("ql-editor");
      // // element[0].innerHTML = element[0].innerHTML.replace(/(<([^>]+)>)/gi, "");
      // element[0].innerHTML += emoji;
      if (this.message === null) this.message = "";
      this.message += emoji;
    },
    onEditorChange({ quill, html, text }) {
      console.log("editor change!", quill, html, text);
      this.content = html;
    },
    selectAutocomplete(item) {
      // var element = document.getElementsByClassName("ql-editor");
      // element[0].innerHTML = item.texto;
      this.message = item.texto;
      this.$bvModal.hide(`autocomplete-modal`);
    },
    calcHeight() {
      this.totalHeight = window.innerHeight;
      if (this.totalHeight > 700) {
        this.windowHeight = window.innerHeight * (70 / 100);
      } else {
        this.windowHeight = window.innerHeight * (50 / 100);
      }
      //this.windowHeight = window.innerHeight * (70 / 100);
    },
    calcularAlturaLista() {
      // if (this.totalHeight > 700 && this.totalHeight < 900) {
      //   return `flex:10;display:flex; flex-direction:column; max-height:73vh !important;`;
      // }
      // if (this.totalHeight <= 700) {
      //   return `flex:10;display:flex; flex-direction:column; max-height:68vh !important;`;
      // }
      // if (this.totalHeight > 900) {
      //   return `flex:10;display:flex; flex-direction:column; max-height:78vh !important;`;
      // }

      return `flex:10;display:flex; flex-direction:column; height:70% !important;`;
    },
    handleScroll(event) {
      if (event.target.scrollTop < 10) {
        //deixar comentado por enquanto
        // this.page++;
        // this.getHistorico();
      }
    },
    getStyleWaChat() {
      return `flex:1; height: calc(100vh - ${this.divMsgHeight}px);flex-shrink: 5; overflow-y:scroll;`;
    },
    getStatus(status) {
      if (status === "Entrou") return this.t(`emAtendimento`);
      if (status === "Encerrado") return this.t(`finalizado`);
      return status;
    },
    async startRecording() {
      try {
        this.files = [];
        await recorder.initAudio();
        await recorder.initWorker();
        recorder.startRecording();
        this.isRecording = true;
      } catch (error) {
        console.error(error);
      }
    },
    cancelRecording() {
      recorder.stopRecording();
      this.isRecording = false;
    },
    async stopRecording() {
      const blob = await recorder.stopRecording();
      this.isRecording = false;
      blob.lastModifiedDate = new Date();
      blob.name = `${uid()}.mpeg`;
      blob.path = URL.createObjectURL(blob);
      this.files.push(blob);
      this.sendFile();
      // recorder.stop().then(({ blob }) => {
      //   this.isRecording = false;
      //   this.files.push(blob);
      //   this.sendFile();
      //   // buffer is an AudioBuffer
      // });
    },
    callback(data) {
      if (data.blob) {
        data.blob.path = data.url;
        this.files.push(data.blob);
      }
    },
    ...mapActions(`xc`, [
      "addAtendimento",
      "selectAtendimento",
      "sendMessage",
      "encerrarAtendimento",
      "getClassificacoes",
      "selectCliente",
      "setTransferenciaModal",
      "sendMessageFile",
      "getDefault",
      "setClassificacao",
      "getClientes",
      "setCliente",
      "addMessages",
      `deleteMsg`,
      `retryMsg`,
      "sendTemplateMsgZenvia",
    ]),

    async getHistorico() {
      if (this.atendimento.pesquisa) return;
      let aux = {};
      aux.texto = `Protocolo #${this.atendimento.id}`;
      aux.idAtendimento = this.atendimento.id;
      aux.inOut = 5;
      aux.queue = this.atendimento.queue;
      aux.agente = this.atendimento.ultimoAgente;
      aux.status = `seen`;
      aux.queueTypeID = this.atendimento.queueTypeID;
      //this.atendimento.messages.unshift(aux);
      let protocolos = await this.getDefault(
        `/api/v2/chat/${this.atendimento.fromID}/protocolosByFromID?max=3&page=${this.page}&order=%5B%7B%22campo%22%3A%22id%22%2C%22ordem%22%3A%22DESC%22%7D%5D`
      );
      if (protocolos) {
        protocolos = protocolos.dados;
        for (let protocolo of protocolos) {
          if (protocolo.queue === this.atendimento.queue) {
            let messages = await this.getDefault(
              `/api/v2/chat/${protocolo.id}/mensagens?max=-1&page=1&order=%5B%7B%22campo%22:%22q.id%22%7D%5D`
            );

            if (messages) {
              messages = messages.dados.slice(0).reverse();
              let aux = {};
              aux.texto = `Protocolo #${protocolo.id}`;
              aux.idAtendimento = protocolo.id;
              aux.inOut = 5;
              aux.queue = protocolo.queue;
              aux.agente = protocolo.ultimoAgente;
              aux.status = `seen`;
              aux.queueTypeID = protocolo.queueTypeID;
              messages.push(aux);
              for (let msg of messages) {
                this.atendimento.messages.unshift(msg);
              }
            }
          }
        }

        //this.atendimento.messages = atendimentoMessages;
      }
    },
    async getClipBoard() {
      //let image = clipboard.readImage();
      const formats = clipboard.availableFormats();
      if (formats.includes("image/png") || formats.includes("image/jpeg")) {
        let dataUri = clipboard.readImage("clipboard").toDataURL();
        toFile(dataUri).then((file) => {
          file.path = dataUri;
          this.files.push(file);
          this.$bvModal.show("anexar-modal");
        });
      }

      // this.files.push(image);
      // this.$bvModal.show("anexar-modal");
    },

    addFile(e) {
      if (this.atendimento.pesquisa) return;
      if (this.files.length > 0) this.files = [];
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      this.files.push(droppedFiles[0]);
      this.$bvModal.show("anexar-modal");
    },
    showCliente() {
      this.selectCliente(this.cliente);
      this.$bvModal.show("modal-cliente");
    },
    async getAutoComplete() {
      let retorno = await this.getDefault(
        `/api/v2/autocomplete?max=-1&page=1&queue=${this.atendimento.queue}`
      );
      if (retorno.dados) {
        this.autoCompletes = retorno.dados;
        this.$bvModal.show("autocomplete-modal");
      }
    },
    getDadosAdicionais() {
      if (this.atendimento.dadosAdicionais) {
        let retorno = "";
        for (let key in this.atendimento.dadosAdicionais) {
          retorno += `      ${key}: ${this.atendimento.dadosAdicionais[key]}`;
        }
        return retorno;
      }
    },
    openImage(file, local) {
      this.modal = true;
      this.file = file;
      this.local = local;
    },
    sendFile() {
      let aux = {};
      aux.texto = this.legenda;
      aux.idAtendimento = this.atendimento.id;
      aux.inOut = 2;
      aux.queue = this.atendimento.queueFrom
        ? this.atendimento.queueFrom
        : this.atendimento.queue;
      aux.agente = this.atendimento.ultimoAgente;
      aux.status = `pending`;
      aux.queueTypeID = this.atendimento.queueTypeID;
      aux.queueAnexos = [];
      aux.repliedMsg = this.repliedMsg;
      aux.email = this.emailExterno ? this.emailExterno : null;
      if (this.repliedMsg) {
        this.alertReplied = false;
      }
      for (let file of this.files) {
        let mime = file.type;
        if (mime == "") mime = "application/octet-stream";
        if (file.path === "") {
          aux.queueAnexos.push({
            caminho: file.caminho,
            mimeType: mime,
          });
        } else {
          aux.queueAnexos.push({
            caminho: file.path,
            mimeType: mime,
          });
        }
      }
      let data = { file: this.files, dados: aux };
      //this.messages.push(aux);

      this.sendMessageFile(data);
      var container = this.$el.querySelector(".wa-chat");
      container.scrollTop = container.scrollHeight;
      this.message = null;
      this.legenda = null;
    },
    sendTemplate(data) {
      data.queue = this.atendimento.queue;
      data.protocolo = this.atendimento.id;
      this.modalTemplate = false;
      this.sendTemplateMsgZenvia(data);
    },
    send() {
      if (this.message == null) return;
      let aux = {};
      let texto = this.message.replace("\n", "<br/>");
      //aux.texto = WhatsTextFormatter.format(this.message);
      aux.texto = texto;
      aux.resposta = WhatsTextFormatter.format(this.message);
      aux.idAtendimento = this.atendimento.id;
      aux.inOut = 2;
      aux.queue = this.atendimento.queue;
      aux.agente = this.atendimento.ultimoAgente;
      aux.status = `pending`;
      aux.queueTypeID = this.atendimento.queueTypeID;
      aux.assunto = this.atendimento.assunto;
      aux.dataHora = new Date();
      aux.email = this.emailExterno ? this.emailExterno : null;
      aux.envelope = this.emailExterno ? true : false;
      aux.repliedMsg = this.repliedMsg;
      if (this.repliedMsg) {
        this.alertReplied = false;
      }
      // var element = document.getElementsByClassName("ql-editor");
      // element[0].innerHTML = "";
      this.message = null;
      //this.messages.push(aux);
      this.sendMessage(aux);
      var container = this.$el.querySelector(".wa-chat");
      container.scrollTop = container.scrollHeight;
      this.message = null;
    },
    replyMsg(msg) {
      this.divMsgHeight = 225;
      this.repliedMsg = msg;
    },
    formataHora(dataHora) {
      moment.locale("pt-br");
      if (moment(dataHora).format("L") === moment(new Date()).format("L")) {
        return moment(dataHora).format("LT");
      } else {
        return moment(dataHora).format("lll");
      }
    },
    formataData(dataHora) {
      moment.locale("pt-br");
      return moment(dataHora).format("L");
    },

    desabilitarTransferencia() {
      if (!this.atendimento.pesquisa) {
        return false;
      }
      if (this.atendimento.pesquisa && this.atendimento.ultimoAgente == null) {
        return false;
      }
      if (this.atendimento.status !== "Encerrado") {
        return false;
      }
      return true;
    },
    async encerraAtendimento() {
      if (this.fila.obrigaClassificar) {
        // return this.httpClient.get<any[]>(`${this.url}/api/v2/chat/${protocolo}/classificacoes?max=-1&page=1`);
        // this.modalClassificacao = true;
        let retorno = await this.getDefault(
          `/api/v2/chat/${this.atendimento.id}/classificacoes?max=-1&page=1`
        );
        //this.encerrarAtendimento(this.atendimento);
        // if (retorno && retorno.dados && retorno.dados.length == 0)
        //   console.log(`ENTROU AQUI`);
        // this.modalClassificacao = true;
        // this.updateClassificar.on(`open`, (event) => {
        //   console.log(`SERA`, event);
        // });
        if (retorno && retorno.dados && retorno.dados.length > 0) {
          this.encerrarAtendimento(this.atendimento);
        } else {
          this.modalClassificacao = true;
        }
      } else {
        this.encerrarAtendimento(this.atendimento);
      }
    },
  },
};
</script>

<style>
.hover {
  padding: 50px;
}
.hover:hover {
  text-align: left !important;
}

.emoji-invoker {
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
}
.emoji-invoker:hover {
  transform: scale(1.1);
}
.emoji-invoker > svg {
  fill: #6c6c6c;
}

.emoji-picker {
  /* margin-top: -500px; */
  position: fixed;
  top: 50%;
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 25rem;
  height: 20rem;
  overflow: scroll;
  padding: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #fff;
  box-shadow: 1px 1px 8px #c7dbe6;
}
.emoji-picker__search {
  display: flex;
}
.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}
.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emoji-picker .emojis:after {
  content: "";
  flex: auto;
}
.emoji-picker .emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
}
.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}
</style>